export function Chip({ icon, label }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6,
                    padding: '5px 11px', background: '#f3f4f6',
                    borderRadius: 999, fontSize: 12, fontWeight: 600,
                    color: '#374151', whiteSpace: 'nowrap' }}>
      {icon && <span style={{ fontSize: 13 }}>{icon}</span>}
      {label}
    </span>
  );
}
